import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ButtonAccentPrimary, ButtonAccentSecondary } from '@components/button';
import { CloseButton } from '@components/close-button';
import { IconCheckCircle } from '@components/icons';
import { Loader } from '@components/loader';
import { Modal } from '@components/modals';
import classNames from 'classnames';

import { SummaryTable } from '../components/SummaryTable';

import { SummarySuccessModalContentProps, SummarySuccessModalProps } from './summary-success-modal.type';

export const SummarySuccessModalContent = ({
  title,
  subtitle,
  description,
  quantity,
  offer,
  addons,
  showHeader,
  mainActionText,
  secondaryActionText,
  bookingLegacyId,
  headerDescription,
  children,
  isInvitation,
  secondaryActionIcon,
  onClickMainAction,
  onClickSecondaryAction,
  onClickClose,
}: SummarySuccessModalContentProps) => {
  const { watch } = useFormContext();

  const name = watch('firstName');
  const lastName = watch('lastName');

  const fullName: string = `${name} ${lastName}`;
  const email: string = watch('email');
  const selectedAddons: string[] = watch('addOns');

  if (!offer) return <Loader />;

  const SecondaryActionIcon = secondaryActionIcon;

  return (
    <>
      <div className='flex justify-end px-6 pt-6'>
        <CloseButton handleClose={onClickClose} />
      </div>
      <section className='px-4 sm:px-20 pb-8 sm:pb-12'>
        <header className='flex flex-col items-center mb-8'>
          <IconCheckCircle className='w-8 h-8 text-primary mb-4' />
          <h2 className='text-headline-m text-primary mb-4'>{title}</h2>
          {headerDescription ? (
            <div className='text-primary'>{headerDescription}</div>
          ) : (
            <>
              {subtitle && <p className='text-body-s text-secondary mb-2'>{subtitle}</p>}
              {email && <p className='text-subtitle-s text-primary mb-0'>{email}</p>}
              {description && <p className='text-body-s text-secondary'>{description}</p>}
              {bookingLegacyId && <p className='text-body-s text-secondary'>{bookingLegacyId}</p>}
            </>
          )}
        </header>
        <SummaryTable
          showHeader={showHeader}
          name={name}
          fullName={fullName}
          quantity={quantity}
          offer={offer}
          addons={addons}
          formAddons={selectedAddons}
          isInvitation={isInvitation}
        />
        <footer className='flex flex-row flex-wrap gap-2 w-full justify-center items-center'>
          {secondaryActionText && onClickSecondaryAction && (
            <ButtonAccentPrimary className='w-full sm:w-auto' onClick={onClickSecondaryAction} type='button'>
              {SecondaryActionIcon && <SecondaryActionIcon className='w-4 h-4 mr-2' />}
              {secondaryActionText}
            </ButtonAccentPrimary>
          )}
          <ButtonAccentSecondary
            className={classNames('w-full', {
              'sm:w-1/2': !secondaryActionText,
              'sm:w-auto': secondaryActionText,
            })}
            onClick={onClickMainAction}
            type='button'>
            {mainActionText}
          </ButtonAccentSecondary>
        </footer>
      </section>
      {children && children}
    </>
  );
};

export const SummarySuccessModal = (props: SummarySuccessModalProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleclose = () => {
    setIsOpen(false);
  };

  return (
    <Modal isOpen={isOpen} handleClose={handleclose}>
      <SummarySuccessModalContent {...props} />
    </Modal>
  );
};
